import { useEffect, useState } from 'react';
import axios from '@/utils/axiosConfig';
import { getApiUrl } from '@/utils/apiUrl';

const APPROVER_ROLES = ['admin', 'org_admin'];

export const usePendingApprovals = (user) => {
  const [count, setCount] = useState(0);
  const isApprover = APPROVER_ROLES.includes(user?.role);

  useEffect(() => {
    if (!isApprover) return undefined;
    let alive = true;
    const load = async () => {
      try {
        const res = await axios.get(`${getApiUrl()}/approvals/count`, { _skipCache: true });
        if (alive) setCount(res.data?.pending || 0);
      } catch (e) {
        console.error('approvals count', e);
      }
    };
    load();
    const id = setInterval(load, 60000);
    const onRefresh = () => load();
    window.addEventListener('approvals:refresh', onRefresh);
    return () => { alive = false; clearInterval(id); window.removeEventListener('approvals:refresh', onRefresh); };
  }, [isApprover]);

  return count;
};
